import {AssayRunSchema} from 'results/assay-schemas/AssaySchemaConstants';
import {RunSchemaSpec} from 'schemas/spec/SchemaConfigConstants';
import * as net from 'util/Net';

interface DuplicateRunSchemaResponse {
  runSchema: AssayRunSchema;
  schemaSpec: RunSchemaSpec;
}

export function duplicateRunSchema({
  schemaId,
  name,
  sqlIdentifier,
  sessionId,
  excludedInputFileConfigs,
  excludedOutputFileConfigs,
}: {
  schemaId: string;
  name: string;
  sqlIdentifier: string | null;
  sessionId: string;
  excludedInputFileConfigs: Array<string>;
  excludedOutputFileConfigs: Array<string>;
}): Promise<DuplicateRunSchemaResponse> {
  return net.postJSONPromise({
    url: `/1/api/run-schemas/${schemaId}:duplicate`,
    data: {
      name,
      sqlIdentifier,
      sessionId,
      excludedInputFileConfigs,
      excludedOutputFileConfigs,
    },
  });
}
